import { apiRequest } from "@/services/api-client";
import { OnboardingInput, OnboardingOutput } from "types/web-app";

export const callOnboarding = (input: OnboardingInput) =>
  apiRequest<OnboardingOutput>("/onboarding", {
    method: "POST",
    body: JSON.stringify(input),
  });
